import { Link } from "react-router-dom";

export default function TrustSection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-100/70">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4">
              Trust &amp; Authority
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">
              Why Trust This Spreadsheet System?
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6">
              AllChinaBuySpreadsheet is built for dropshippers, resellers, sneaker buyers, and bulk importers
              who need reliable, structured product data from China&rsquo;s top marketplaces.
            </p>
            <p className="text-base text-foreground-600 leading-relaxed mb-8">
              We transform raw China market data into clean, readable spreadsheets so you can make faster
              and safer buying decisions — without the noise of unreliable listings.
            </p>
            <Link
              to="/allchinabuyspreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              Read Our Full Spreadsheet Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Trust Stats */}
          <div className="grid grid-cols-2 gap-4">
            {[
              { value: "14+", label: "Product Categories" },
              { value: "500+", label: "Verified Suppliers" },
              { value: "Daily", label: "Spreadsheet Updates" },
              { value: "40-70%", label: "Cost Savings" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="p-5 bg-background-50 border border-background-200/70 rounded-lg text-center"
              >
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}